/** Shared Tailwind classes for Event stats (light + dark). */
export const statsPageTitle =
  "text-2xl font-semibold tracking-tight text-surface-900 dark:text-surface-100";

export const statsSectionTitle =
  "text-sm font-semibold text-surface-900 dark:text-surface-100";

export const statsMuted = "text-surface-600 dark:text-surface-400";

export const statsSubtle = "text-surface-500 dark:text-surface-400";

export const statsProgressTrack =
  "h-2 w-full overflow-hidden rounded-full bg-surface-200 dark:bg-surface-700";

export const statsSearchForm =
  "flex w-full items-center gap-2 rounded-lg border border-surface-200 bg-surface-50 px-2 py-1 shadow-sm dark:border-surface-600 dark:bg-surface-800";

export const statsSearchInput =
  "h-10 w-full flex-1 bg-transparent px-2 text-sm text-surface-900 outline-none placeholder:text-surface-500 dark:text-surface-100 dark:placeholder:text-surface-500";

export const statsSearchDivider = "h-6 w-px bg-surface-200 dark:bg-surface-600";

export const statsTeamCardInactive =
  "border-red-200/80 bg-red-50 dark:border-red-900/50 dark:bg-red-950/35";

export const statsLocaleBadge =
  "rounded bg-surface-100 px-2 py-1 text-xs font-semibold uppercase text-surface-600 dark:bg-surface-700 dark:text-surface-300";

export const statsParticipantName =
  "truncate text-sm font-medium text-surface-900 dark:text-surface-100";
